import { format } from 'date-fns';
import queryString from 'query-string';
import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { IHistory } from 'src/interfaces';

import { setLoading, setSuccess } from '../../../actions/loadingActions';
import { IDailyForms, IFilters } from '../../../interfaces';
import { DailyFormsModel } from '../../../model/DailyFormModel';
import { getDailyFormData } from '../../../services/dailyFormService';
import { splitDate } from '../../../utils/generalUtils';
import { BasePage } from '../../reusableComponents/BasePage';
import { PieChart } from '../../reusableComponents/ChartComponents/PieChart';
import { RDatePicker } from '../../reusableComponents/DatePicker';
import { ListPage } from '../../reusableComponents/ListPage';
import { RegionFilter } from '../../reusableComponents/RegionFilter';
import { ListItem } from './ListItem';

export interface IDailyReportsProps {
    instances: DailyFormsModel[];
    dailyForms: IDailyForms;
    filters: IFilters;
    history: IHistory;
    location: any;
}

export interface IDailyReportsState {
    date: Date;
    regionName: string;
}

export class DailyReportsImpl extends React.Component<IDailyReportsProps, IDailyReportsState> {

    constructor(props) {
        super(props);
        let date = new Date();
        let region = 'All';
        if (this.props.location.search) {
            date = queryString.parse(this.props.location.search).date;
            region = queryString.parse(this.props.location.search).region;
        }
        this.state = { date: new Date(date), regionName: region };
    }

    promise = async () => {
        const { filters } = this.props;
        let date = format(new Date(), 'YYYY-MM-DD');
        let region = 'All';
        if (this.props.location.search) {
            date = queryString.parse(this.props.location.search).date;
            region = queryString.parse(this.props.location.search).region;
        }
        const { mm, dd, yyyy } = splitDate(date);
        await getDailyFormData(mm, dd, yyyy, 'All');
    }

    handleDateFilter = async (e) => {
        this.setState({
            date: e
        });
        const { mm, dd, yyyy } = splitDate(format(e, 'YYYY-MM-DD'));
        setLoading('DailyReports');
        const queryString = `?date=${format(e, 'YYYY-MM-DD')}&&region=${this.state.regionName}`;
        await getDailyFormData(mm, dd, yyyy, this.state.regionName);
        this.props.history.push(`/reports/daily${queryString}`);
        setSuccess('DailyReports');
    }

    handleRegionFilter = async (filterName, regionName) => {
        this.setState({ regionName });
        const { mm, dd, yyyy } = splitDate(format(this.state.date, 'YYYY-MM-DD'));
        setLoading('DailyReports');
        const queryString = `?date=${format(this.state.date, 'YYYY-MM-DD')}&&region=${regionName}`;
        await getDailyFormData(mm, dd, yyyy, regionName);
        this.props.history.push(`/reports/daily${queryString}`);
        setSuccess('DailyReports');
    }

    render() {
        const { instances } = this.props;
        return (
            <BasePage className="list-page-base" pageTitle="Daily Reports" >
                <ListPage
                    identifier="DailyReports"
                    instances={instances}
                    listItemComponent={ListItem}
                    searchBy={['PlantId', 'Region', 'type', 'Date']}
                    instanceOf={'plantInfo'}
                    promise={this.promise}
                    pageHeadings={['#', 'PlantID', 'Region', 'Type', 'Date']}
                    cols={[1, 3, 3, 3, 2]}
                    searchPlaceHolder="Enter date, plant or form type to search..."
                    emptyListMessage="No Daily Reports found"
                    listItemProp={format(this.state.date, 'MMMM YYYY')}
                    chartFilter={<div className="filter-container" >
                        <RDatePicker
                            value={this.state.date}
                            onChange={this.handleDateFilter}
                        />
                        <RegionFilter
                            selectedValue={this.state.regionName}
                            onChange={this.handleRegionFilter}
                        />
                    </div>}
                />
            </BasePage>
        );
    }
}

export function mapStateToProps(state) {
    const instances = DailyFormsModel.list(state);
    return {
        instances, filters: state.dashboard.get('dailyFilter')
    };
}

export const DailyReports = withRouter(connect<{}, {}, IDailyReportsProps>(mapStateToProps)(DailyReportsImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Reports/Daily/DailyReports.tsx